// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//= require clipboard

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import "channels"
import Chart from "chart.js/auto";
global.Chart = Chart;
require("jquery")
require("common.js")
require("match_form.js")
require("global_menu.js")
require("sidebar.js")
require("dropdown_menu.js")
require("rule_form_change.js")
require("components/player_select_modal.js")
require("player_select.js")
require("toggle.js")
require("faq.js")
require("changelog_year_nav.js")
require("league.js")
require("leagues/utils.js")
require("leagues/select_players.js")
require("leagues/select_players_filter.js")
require("leagues/player_stats_chart.js")
require("leagues/title_settings.js")
require("leagues/form_validation.js")
require("leagues/team_color_picker.js")
require("leagues/team_setup_members.js")
require("leagues/team_setup_assignment.js")
require("leagues/daily_stats_chart.js")
require("leagues/daily_date_filter.js")
require("leagues/team_ranking_chart.js")
require("leagues/graph_mode_toggle.js")
require("leagues/league_graph_filter.js")
require("leagues/team_stats_chart.js")
require("leagues/team_select_players.js")
require("leagues/team_ui_shared.js")
require("leagues/team_edit.js")
require("leagues/team_bulk_info_edit.js")
require("leagues/delete_confirm_modal.js")
require("leagues/point_adjustments.js")
require("leagues/save_ranking_image.js")
require("leagues/league_kuroko_setting.js")
require("leagues/league_branding.js")
require("leagues/csv_import.js")
require("leagues/league_form_leave_guard.js")
require("match_group.js")
require("show_modal.js")
require("clipboard.js")
require("share_modal.js")
require("tip_form.js")
require("matches/chip_inline_form.js")
require("loading.js")
require("components/form_counter.js")
require("components/form_collapsible.js")
require("components/dropdown.js")
require("components/toast.js")
require("components/hover_tooltip.js")
require("components/filter_bar.js")
require("parent_option.js")
require("point_table.js")
require("admin_player_stats.js")
require("subscription.js")
require("notice_form.js")
require("notice_read.js")
require("hands.js")
require("yakuman_form.js")
require("survey.js")
require("limited_offer_banner.js")
require("hidden_players.js")

require("email_validation.js")
require("email_suggest.js")

require("players/play_type_toggle.js")
require("players/player_results.js")
require("players/stats_chart.js")
require("players/chart_period_filter.js")

require("tops/play_type_toggle.js")
require("tops/landing_reveal.js")
require("tops/landing_count_up.js")
require("tops/landing_carousel.js")
require("tops/landing_tabs.js")
require("tops/landing_hero_gallery.js")
require("tops/landing_mobile_cta.js")
require("tops/landing_faq.js")
require("tops/landing_html_scroll.js")

require("point_calendars.js")
require("point_calendars/heatmap.js")
require("point_calendars/stats_bar.js")
require("point_calendars/daily_matches_modal.js")
require("popover_tooltip.js")
require("users/stat_card_settings.js")
require("onboarding_dismiss.js")
require("mobile_nav.js")
require("gtm.js")

Rails.start()
Turbolinks.start()

// Register Service Worker (no offline caching)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service_worker.js').catch(() => {
      // Ignore registration errors silently
    });
  });
}